/**
 * DocLink `ConsultStatus` enum (numeric values from API / SQL).
 * Labels match `[Description("…")]` on the C# enum members.
 */

export const DocLinkConsultStatus = {
  None: 0,
  Request: 1,
  Placed: 2,
  PendingPayment: 3,
  Reviewing: 4,
  WaitingRoom: 5,
  Action: 6,
  Issued: 7,
  Completed: 8,
  Cancelled: 9,
  WaitingForInfo: 10,
  ClinicToUpdate: 11,
  Started: 12,
  Paused: 13,
  ApptCompleted: 14,
  Escalated: 15,
  Missed: 16,
  DocUploaded: 17,
  ScriptReceived: 18,
  Confirmed: 19,
};

/** Display string per status code (same as C# `Description`). */
export const DocLinkConsultStatusLabels = {
  [DocLinkConsultStatus.None]: "None",
  [DocLinkConsultStatus.Request]: "Request sent",
  [DocLinkConsultStatus.Placed]: "Placed",
  [DocLinkConsultStatus.PendingPayment]: "Pending payment",
  [DocLinkConsultStatus.Reviewing]: "Clinic processing",
  [DocLinkConsultStatus.WaitingRoom]: "In Waiting Room",
  [DocLinkConsultStatus.Action]: "Doctor is about to call",
  [DocLinkConsultStatus.Issued]: "Consult Ending",
  [DocLinkConsultStatus.Completed]: "Completed",
  [DocLinkConsultStatus.Cancelled]: "Cancelled",
  [DocLinkConsultStatus.WaitingForInfo]: "No Answer",
  [DocLinkConsultStatus.ClinicToUpdate]: "Clinic to update",
  [DocLinkConsultStatus.Started]: "In Appt Now",
  [DocLinkConsultStatus.Paused]: "Appt Paused",
  [DocLinkConsultStatus.ApptCompleted]: "Appt Ended",
  [DocLinkConsultStatus.Escalated]: "Escalated",
  [DocLinkConsultStatus.Missed]: "Missed Appt",
  [DocLinkConsultStatus.DocUploaded]: "Document Received",
  [DocLinkConsultStatus.ScriptReceived]: "Script Received",
  [DocLinkConsultStatus.Confirmed]: "HubMed Confirmed",
};

export function getDocLinkConsultStatusLabel(status) {
  const t = Number(status);
  if (!Number.isFinite(t)) return "Unknown status";
  return DocLinkConsultStatusLabels[t] ?? `Unknown status (${t})`;
}
